<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 要货记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="所属门店">
          <el-button-group>
            <el-button
              @click="onActiveClick('demand')"
              :type="activeName == 'demand' ? 'primary' : 'default'"
            >
              当前门店
            </el-button>
            <el-button
              @click="onActiveClick('demand_storehouse')"
              :type="activeName == 'demand_storehouse' ? 'primary' : 'default'"
            >
              下级门店
            </el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="记录状态">
          <el-select
            v-model="formInline.optStatus"
            @change="queryClick"
            style="width: 140px"
            placeholder="记录状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="等待下单" value="1"></el-option>
            <el-option label="部分下单" value="2"></el-option>
            <el-option label="全部下单" value="3"></el-option>
            <el-option label="已完成的" value="4"></el-option>
            <el-option label="已关闭的" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px">
        <div>
          <el-button
            v-if="activeName == 'demand'"
            :size="$xUISize"
            @click="createClick"
            type="primary"
          >
            新建要货单
          </el-button>
        </div>
        <template v-if="!refresAble">
          <demand-by-store
            v-if="activeName == 'demand'"
            :queryModel="queryModel"
            :storeGuid="storeGuid"
          />
          <demand-by-storehouse
            v-else-if="activeName == 'demand_storehouse'"
            :queryModel="queryModel"
            :storeGuid="storeGuid"
          />
        </template>
      </div>
    </el-card>
  </div>
</template>

<script>
import customerStoreSelect from '../../../../components/business/customerStoreSelect.vue';
import demandByStorehouse from './_index_storehouse.vue';
import demandByStore from './_index_store.vue';
import demandForm from './form.vue';

export default {
  components: {
    demandByStore,
    demandByStorehouse,
    customerStoreSelect,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({
        optCancel: "0",
        storeGuid: this.storeGuid,
      }, this.queryModel);
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  methods: {
    refresh() {
      this.refresAble = true;
      this.$nextTick(() => {
        this.refresAble = false;
      })
    },
    clearClick() {
      this.formInline = {
        optStatus: "",
        queryValue: ""
      }
      this.queryModel = {
        optStatus: "",
        queryValue: ""
      };
    },
    queryClick() {
      this.queryModel = Object.assign({
      }, this.formInline);
    },
    createClick() {
      this.$drawer.openDrawer({
        title: '创建要货单',
        refresh: this.refresh,
        component: demandForm,
        params: {
          storeGuid: this.storeGuid
        },
      });
    },
    onActiveClick(mode) {
      this.activeName = mode;
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.onActiveClick("demand")
    }
  },
  data() {
    return {
      storeGuid: "",
      activeName: "demand",
      refresAble: false,
      queryModel: {
        optStatus: "",
        queryValue: ""
      },
      formInline: {
        optStatus: "",
        queryValue: ''
      },
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  }
};
</script>